export default __webpack_public_path__ + "static/mainVideo-ce0844940d66a3b317af1c2ad6a09e93.mp4";